const verticalMenuService = () => {
    if ($(".vertical-menu-service").length == 0) return;
    initSlide();
    $(".vertical-menu-service li").first().click()
    $(window).on('resize', function () {
        $(".vertical-menu-service li").first().click()
    })
}
const initSlide = () => {
    let slickInstance;

    $(".vertical-menu-service").on("click", "li", function () {
        const width = $(this).outerWidth();
        const height = $(this).outerHeight();
        const top = $(this).position().top + 15;
        const $parent = $(this).parents(".vertical-menu-service");
        $parent.find(".background-active").css({
            top: top,
            width: width + 30,
            height: height
        })
        $parent.find(".background-index").css({
            top: top + (height / 2) - 14,
        })
        $parent.find(".active").removeClass("active")
        $(this).addClass("active")
        // console.log($(this), $(this).position())

        if (slickInstance) {
            const index = $(this).index()
            slickInstance.slick('slickGoTo', index);

        }
    })

    slickInstance = $(".vertical-menu-service-slide").slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        adaptiveHeight: true,
        centerMode: true,
        vertical: true,
        //verticalSwiping: false,
        arrows: false,
    })
}

module.exports = verticalMenuService
